import { action, computed } from 'mobx';

import { AppManager, Variables } from 'core';

import { modalStore } from 'apps/modals/app';
import { clientStore } from 'apps/client/app';

import { CategoryQuery, CategoryThreadsQuery } from 'apps/forum/gql';
import {
  CategoryModel,
  CategoryApp,
  ForumApp,
  ForumModel,
} from 'apps/forum/app';
import { ThreadConnManager } from 'apps/forum/main/appManager';
import { ThreadForm } from 'apps/forum/threadForm/index';

export class CategoryAppManager extends AppManager {
  static registryName = 'CategoryAppManager';
  constructor(parent, init = {}) {
    super(parent, init);
    this.AppRef('categoryPage', CategoryApp);
    this.AppRef('forum', ForumApp);
    this.threadsConn = new ThreadConnManager(this, {
      slug: init.params.get('initiative'),
      loadMoreQuery: CategoryThreadsQuery,
      categoryId: init.params.get('categoryId'),
    });

    this.variables = new Variables({
      slug: () => init.params.get('initiative'),
      urlId: () => init.params.get('categoryId'),
      threadCursor: () => this.threadsConn.endCursor,
      threadSortBy: () => this.threadsConn.sortBy,
      threadBatchSize: () => this.threadsConn.batchSize,
    });
    this.variables.onChange(['categoryId'], this.NewCategoryId);
    clientStore.context.set('categoryAppManager', this);
  }

  @computed
  get loading() {
    return (
      this.queries.get('categoryPage')?.loading ||
      (!this.notFound && !this.categoryPage)
    );
  }

  @computed
  get notFound() {
    return this.queries.get('categoryPage')?.notFound;
  }

  @action
  NewVariables = () => {
    this.threadsConn.NewVariables();
    this.NewCategoryId();
  };

  @action
  NewCategoryId = () => {
    this.threadsConn.NewVariables();
    const q = new CategoryQuery(this, {
      queryKey: 'categoryPage',
      onSysErr: this.onSysErr,
    });
    q.process(
      categoryPage => CategoryModel.Load(categoryPage),
      this.CategoryPageUpdate,
    );
    q.process(categoryPage => ForumModel.Load(categoryPage), this.ForumUpdate, {
      subPath: 'forum',
    });
    q.process(this.threadsConn.process, this.ThreadsUpdate, {
      subPath: 'threads',
    });
    q.query();
  };

  @action
  ThreadsUpdate = (threads, query) => {
    this.threadsConn.pushResultIfFirst(threads, query);
  };

  @action
  CategoryPageUpdate = categoryModel => {
    if (categoryModel) {
      this.categoryPage = categoryModel;
    }
  };

  @action ForumUpdate = forumModel => {
    if (forumModel) {
      this.forum = forumModel;
    }
  };

  @action
  onSysErr = () => {
    // TODO
  };

  @action
  OpenThreadForm = () => {
    modalStore.SetModalComponent(ThreadForm, {
      parent: this,
      categoryId: this.categoryPage.id,
      categoryTitle: this.categoryPage.title,
      categoryColor: `#${this.categoryPage.color}`,
      isMember: this.forum.isMember,
      hideOnlyOnEsc: true,
    });
  };
}
